module.exports = __webpack_public_path__ + "assets/RetinaNarr-Black.5fc7f48ff1093233a05a751dabb5c077.woff";